<template>
  <div>
    <div class="modal fade" id="training-modal" role="dialog" aria-labelledby="myLargeModalLabel">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header text-center">

                    <h5 class="w-100 pl-5">Tutoriais e treinamentos</h5>

                    <button type="button" data-dismiss="modal" aria-hidden="true" class="close modal-close">
                        <i class="ti-close"></i>
                    </button>

                </div>

                <div class="panel-body text-center">
                    <p>Para acessar os vídeos de treinamento, <a target="_blank" href="https://vimeo.com/album/5613326">clique
                        aqui.</a></p>
                    <p>Insira a senha: <strong>magalu@tagsell</strong></p>
                    <p>Se estiver procurando pelo tutorial do sistema, clique no <i class="icon s7-info"></i>.</p>
                    <h3>Bom treinamento!</h3>
                </div>
            </div>
        </div>
    </div>
    <LicenseInfoModal :license-days-to-expires="differenceDay" :show-modal="alertModal" />
  </div>
</template>

<script>
import LicenseInfoModal from "./dashboard/LicenseInfoModal.vue";

  export default {
    name: 'modal-training',

    components: {
      LicenseInfoModal,
    },

    mounted() {
      this.getLicenseValidity();
    },

    data: () => ({
      alertModal: false,
      differenceDay: null
    }),

    methods: {
      getLicenseValidity() {
        axios.get('/ajax/validity')
            .then((response) => {
              const differenceInDays = this.getDifferenceInDays(new Date(), response.data.expire_date);
              this.differenceDay = differenceInDays;
              const daysOpenModal = [15, 10, 5, 1];

              for (const days of daysOpenModal) {
                const keyLocalStorage = `openModal-${response.data.expire_date}-${days}`;
                const isOpenModal = localStorage.getItem(keyLocalStorage);

                if (days === differenceInDays && !isOpenModal) {
                  this.alertModal = true;
                  localStorage.setItem(keyLocalStorage,  'true');
                  break;
                }
              }
            });
      },

      getDifferenceInDays(date1, date2) {
        const firstDate = new Date(date1);
        const secondDate = new Date(date2);


        const timeDifference = Math.abs(secondDate - firstDate);

        return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      },
    }
  };
</script>

<style scoped>
  .modal-header{
      background-color: transparent;
      color: #ff0061;
  }

  .modal-header h3 {
      padding-left: 27px;
  }

  .panel-body a{
      text-decoration: underline;
      color: gray;
  }

  .panel-body p {
      font-size: 15px;
  }

  .panel-body h3 {
      font-size: 20px;
      margin-bottom: 18px;
  }

  .panel-body {
      padding-bottom: 0;
      padding-top: 5px;
  }

  strong {
      color: #0f7ec2;
  }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ModalTraining.vue